module.exports = __webpack_public_path__ + "img/404.d3375c69.png";